<template>
    <span class="readmore" @click.prevent.stop="openArticle">
        <span class="readmore__external">
            <a :href="url" target="_blank"><i aria-hidden="true" class="fa fa-fw fa-external-link"></i></a>
        </span>
        <span class="readmore__tag">Read more: </span>
        <span class="readmore__link"><slot></slot></span>
    </span>
</template>

<script>
    export default {
        props: [
        	"url"
        ],
        methods: {
        	openArticle () {
				this.$router.push(this.url);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .readmore {
        max-width: 30rem;
        text-align: center;
        padding: .5rem;
        border: 1px solid #ddd;
        background: rgba(255, 255, 255, 0.11);
        color: #1f6dc6;
        display: block;
        border-radius: 5px;
        margin: 1.5rem auto;
        font-size: 1.1rem;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        box-shadow: 0 3px 10px 2px rgba(0,0,0,.1);
        &__external {
            position: absolute;
            right: 0;
            padding: 0 10px;
            height: 100%;
            top: 0;
            display: flex;
            align-items: center;
            border-left: 1px solid #577f40;
            a {
                color: #577f40;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// readmore.vue?b29b5448